// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"278":"4d3b767f","496":"2d6522a3"}[chunkId] + ".chunk.js";
};